'use strict';

require('./plugins/storelocator/jquery.storelocator');
const { fetchProductsRatingHtml } = require('./product/reviews');

$(function () {
    fetchProductsRatingHtml('detail');
});
